module.exports = __webpack_public_path__ + "img/qrcode.a3dc6f4a.png";